import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import {ListEventData} from 'organization/EventList'

export default function ArchiveEventButton(props: {
  event: ListEventData
  setShowArchiveDialog: (show: boolean) => void
}) {
  const {event, setShowArchiveDialog} = props

  return (
    <MenuItem
      aria-label="archive event"
      disabled={event.is_deleting}
      onClick={() => {
        setShowArchiveDialog(true)
      }}
    >
      Archive
    </MenuItem>
  )
}
